import UserActionTypes from "./users.types";

const INITIAL_STATE = {
  user: null,
  status: null
};

const usersReducer = (state = INITIAL_STATE, action) => {
  console.log("PL", action);
  switch (action.type) {
    case UserActionTypes.GET_USER:
      return { ...state, user: action.payload };
    case UserActionTypes.ADD_USER:
      return { ...state, user: action.payload };
    case UserActionTypes.STATUS_USER:
      return { ...state, status: action.payload };
    case UserActionTypes.CLEAR_USER:
      return { ...state, user: null, status: null };
    default:
      return state;
  }
};

export default usersReducer;
